import { PayloadActionCreator, createAction } from '@reduxjs/toolkit'
import { call, put, takeEvery } from 'redux-saga/effects'
import {
  ResponseShop,
  ResponseAvailableCampaignTypes,
  CampaignService,
  ShopService,
} from '@ads/front-core/api'
import { apiError } from '@ads/front-core/store/sagas/apiErrorSaga'
import { setShop } from 'store/reducers/shop/setShopReducer'
import { setAvailableCampaignTypes } from 'store/reducers/campaign/setAvailableCampaignTypesReducer'
import { fetchArchiveCampaigns } from './fetchArchiveCampaignsSaga'

interface FetchShopDataProps {
  shopId: number
}

type FetchShopDataSaga = ReturnType<
  PayloadActionCreator<FetchShopDataProps, string>
>

export const fetchShopData = createAction<FetchShopDataProps>(
  'saga/fetchShopData',
)

export function* sagaFetchShopData(): Generator {
  yield takeEvery(fetchShopData.type, fetchShopDataSaga)
}

export function* fetchShopDataSaga({ payload }: FetchShopDataSaga): Generator {
  const { shopId } = payload

  try {
    if (!shopId) {
      return
    }

    const responseShop = yield call(ShopService.getShopById, { shopId })
    const shop = responseShop as Required<ResponseShop>
    yield put(setShop(shop))

    const res = yield call(CampaignService.getAvailableCampaignTypes, {
      shopId,
    })
    yield put(
      setAvailableCampaignTypes({
        shopId,
        types: res as ResponseAvailableCampaignTypes,
      }),
    )
    yield put(fetchArchiveCampaigns({ shopId }))
  } catch (error) {
    yield put(setShop(undefined))
    yield put(apiError({ error }))
    if (error?.status === 401) {
      window.localStorage.removeItem('currentClientId')
      window.localStorage.removeItem('currentShopId')
    }
  }
}
